import PropTypes from 'prop-types';
import Icon, { GLYPHS } from '../../common/icon';
import { t } from '../../../modules/infra/i18n';

export const AiButton = ({ text, onClick, onMouseDown }) => {
  return (
    <div className="c-row c-content btn-ai-container">
      <div className="c-btn-container c-outlined-gradient-ai">
        <button type="button" className="c-btn c-btn--blank icon-button" onClick={onClick} onMouseDown={onMouseDown}>
          <div className="c-row c-content">
            <Icon glyph={GLYPHS.aiIcon} size="small" className="ai-icon" />
            <p className="text-m text-strong ">{text || t('engage:ai_button.default_text')}</p>
          </div>
        </button>
      </div>
    </div>
  );
};

AiButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func,
};

AiButton.defaultProps = {
  text: null,
  onMouseDown: undefined,
};
